export enum MultiSetsMulticampaignPromotionStates {
    INIT = 'init',
    BASIC = 'basic',
    RESTORE = 'restore',
    START = 'start',
    IN_PROGRESS = 'inProgress',
    IN_PROGRESS_SPINNING = 'inProgressSpinning',
    LAST_PROMOTION = 'lastPromotion',
    END = 'end',
    TERMINATED = 'terminated',
    DISABLED = 'disabled'
}